import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight, Plus } from 'lucide-react';
import { Highlight } from './Highlight';
import { QrPattern } from './QrPattern';
export function ConnectPhoneMockup() {
  const reduce = useReducedMotion();
  return <div className="flex w-full items-center justify-center gap-[2.4cqw] font-body" data-id="element-63" data-mp="z2c03l4w10gl">
      <div className="border-2 border-mm-charcoal bg-mm-white p-[1.4cqw] shadow-[0.6cqw_0.6cqw_0_0_rgba(34,34,34,0.12)]" data-id="element-64" data-mp="z0howyjf4mpp">
        <p className="text-[1cqw] font-semibold uppercase tracking-[0.12em] text-mm-mid-gray" data-id="element-65" data-mp="q1xa48gzax6r">
          On your computer
        </p>
        <QrPattern className="mt-[0.8cqw] w-[14cqw]" data-id="element-66" data-mp="l3m4k9xpv8uc" />
        <p className="mt-[0.8cqw] text-[1cqw] text-mm-mid-gray" data-id="element-67" data-mp="g3hlcc5fc00f">Example only</p>
      </div>

      <ArrowRight className="h-[2.4cqw] w-[2.4cqw] shrink-0 text-mm-orange" aria-hidden="true" data-id="element-68" data-mp="g5u7z2m4myjt" />

      <div className="flex h-[30cqw] w-[16cqw] flex-col border-[0.5cqw] border-mm-charcoal bg-mm-white" data-id="element-69" data-mp="2fe7u68m9xh0x">
        <div className="mx-auto mt-[0.6cqw] h-[0.4cqw] w-[4cqw] bg-mm-charcoal" data-id="element-70" data-mp="2gk3iq9xzup1u" />
        <p className="mt-[1cqw] px-[1.2cqw] text-[1.1cqw] font-semibold text-mm-black" data-id="element-71" data-mp="2gm6ihloy7wjr">
          Authenticator
        </p>
        <div className="mt-[1cqw] border-y border-mm-light-gray px-[1.2cqw] py-[1cqw]" data-id="element-72" data-mp="26m5tbj4eem7n">
          <p className="text-[1cqw] font-semibold text-mm-charcoal" data-id="element-73" data-mp="2bl0ntibq9z7l">Stripe</p>
          <p className="text-[1cqw] text-mm-mid-gray" data-id="element-74" data-mp="2bn3absdo9a7k">Leslie Outreach</p>
          <p className="mt-[0.4cqw] font-heading text-[2.6cqw] font-bold tracking-[0.06em] text-[#1A73E8]" data-id="element-75" data-mp="2zbw8lvhrnu5c">
            482 913
          </p>
          <div className="mt-[0.6cqw] h-[0.3cqw] bg-mm-light-gray" data-id="element-76" data-mp="34biqwjcgc0l0">
            <motion.div className="h-full bg-mm-orange" initial={{
            width: '100%'
          }} animate={{
            width: reduce ? '60%' : '0%'
          }} transition={reduce ? {
            duration: 0
          } : {
            duration: 30,
            ease: 'linear',
            repeat: Infinity
          }} data-id="element-77" data-mp="2pk8m8902h3aq" />
          </div>
          <p className="mt-[0.6cqw] text-[1cqw] text-mm-mid-gray" data-id="element-78" data-mp="qrvk14qmn3d">New number every 30 sec</p>
        </div>
        <div className="mt-auto flex justify-end p-[1.2cqw]" data-id="element-79" data-mp="3rxb4tbuxe4zk">
          <Highlight tone="go" tag="Tap +" side="left" data-id="element-80" data-mp="3rxumcrgnyrd2">
            <span className="flex h-[3cqw] w-[3cqw] items-center justify-center bg-[#1A73E8] text-white" data-id="element-81" data-mp="3nuomc1k59wf1">
              <Plus className="h-[1.6cqw] w-[1.6cqw]" strokeWidth={3} data-id="element-82" data-mp="3ivbneig00yw3" />
            </span>
          </Highlight>
        </div>
      </div>
    </div>;
}